import { render, staticRenderFns } from "./carousel-special.vue?vue&type=template&id=528634f2&scoped=true"
import script from "./carousel-special.vue?vue&type=script&lang=js"
export * from "./carousel-special.vue?vue&type=script&lang=js"
import style0 from "./carousel-special.vue?vue&type=style&index=0&id=528634f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528634f2",
  null
  
)

export default component.exports